import { Widget } from "@rjsf/core";

import { FormMessage, MultiSelect } from "@xometry/xometry_loft";
import _ from "lodash";
import { useMemo } from "react";

import { getEnumOptions } from "../utils";
import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { Section } from "./Shared.style";

export const LoftMultiSelectField: Widget = ({
  onChange,
  schema,
  options,
  required,
  rawErrors,
  disabled,
  placeholder,
  value,
}) => {
  const parsedOptions = useMemo(() => {
    return getEnumOptions(schema, options);
  }, []);

  const parsedValues = useMemo(() => {
    if (!value) {
      return [];
    }
    if (!_.isArray(value)) {
      return [value];
    }
    return value?.map(vl => ({ label: vl, value: vl }));
  }, [value]);

  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);
  return (
    <div css={Section}>
      <LabelWithOptionalFlag
        required={required}
        tooltip={(options?.tooltip || "") as string}
      >
        {schema.title}
      </LabelWithOptionalFlag>
      <MultiSelect
        defaultValue={parsedValues}
        disabled={disabled}
        invalid={isInvalid}
        options={parsedOptions}
        placeholder={placeholder}
        onChange={selectedOptions => {
          onChange(selectedOptions.map(({ value: newValue }) => newValue));
        }}
      />
      <FormMessage invalid={isInvalid}>
        {rawErrors ? rawErrors[0] : ""}
      </FormMessage>
    </div>
  );
};
